import React from "react";
import styles from "./EditActionButton.module.scss";
import { EDIT } from "../../../constants";

export interface EditActionButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const EditActionButton: React.FC<EditActionButtonProps> = ({ onClick, disabled = false }) => (
  <button type="button" className={styles.form_edit_btn} onClick={onClick} disabled={disabled}>
    <i className="fa fa-pencil" aria-hidden="true" />
    <span>{EDIT}</span>
  </button>
);
